// removed by extract-text-webpack-plugin
module.exports = {"container":"_323MJ","image":"_2yaPv"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-image/post-image.scss
// module id = 987
// module chunks = 0 3 4 5 6